import { useMemo } from "react";
import { useUserPreferences } from "@/features/user-preferences";
import { useDataModelContext } from "@/entities/data-model";
import { useMetadataQuery } from "@/entities/form-metadata";
import { useUserPreferencesQuery } from "@/entities/user-preferences";
import { mapDataModelToFormValues } from "../metadata-converters/mapDataModelToFormValues";
import { populateFormValuesFromMetadata } from "../metadata-converters/populateFormValuesFromMetadata";

interface UseDefaultFormValuesArgs {
    isEditForm?: boolean;
}

export const useDefaultFormValues = ({ isEditForm = false }: UseDefaultFormValuesArgs) => {
    const dataModel = useDataModelContext();
    const { data: formMetadata } = useMetadataQuery();

    const { data: userPreference } = useUserPreferencesQuery();
    const dataModelWithUps = useUserPreferences({ dataModel, formMetadata, isEditForm });

    return useMemo(() => {
        const sourceFormValues = mapDataModelToFormValues(dataModelWithUps);
        const matchAllTermsExactly = userPreference?.UserPreferences.MatchAllTermsExactly ?? false;
        return populateFormValuesFromMetadata({
            isEditForm,
            matchAllTermsExactly,
            formMetadata,
            sourceFormValues,
        });
    }, [dataModelWithUps, formMetadata, isEditForm, userPreference?.UserPreferences.MatchAllTermsExactly]);
};
